import React, { useEffect } from "react";

const AboutUs = () => {
	return (
		<div className="flex items-center justify-center bg-black" id="about">
			<div
				className="grid grid-cols-1 md:grid-cols-2 items-center justify-center gap-4 md:max-w-7xl md:mx-auto flex-col my-10 lg:my-20  rounded-3xl p-10"
				data-aos="fade-up"
			>
				<div className="">
					<img src={"./dene.png"} alt="token_image" />
				</div>
				<div className="pl-5 ">
					<h1 className="text-4xl lg:text-6xl text-white lg:mt-0 mt-5  font-semibold">
						About
					</h1>{" "}
					<span className="text-purple-700  text-4xl md:text-6xl lg:text-8xl font-bold   ">
						Medusa
					</span>
					<p className="text-gray-400 leading-relaxed pt-10 text-lg ">
						WHAT ARE Moondusa? Moondusa is an NFT collection on the Solana
						Blockchain consisting of 444 exclusive nfts. They are cool, funny
						and they love to get in trouble!! Adopting a Fance Ewe is not easy,
						but you can be the chosen one who can change your and their future
						forever. We aim to build a community that is driven in helping each
						other and grow together in different work fields. The community will
						be able to learn from each other's expertise. The people who bring
						value in the community will be rewarded.
					</p>
				</div>
			</div>
		</div>
	);
};

export default AboutUs;
